<template>
    <div id="c_tabs" class="card-container">
        <a-tabs :type="tabsType" @change="tabChange">
            <a-tab-pane :key="item.tabKey" :tab="item.tabName" :disabled="item.tabDisabled" v-for="item in tabsData">
                <slot></slot>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
export default {
    props: {
        tabsType: {
            type: String,
            // 可选 line、card、editable-card 类型
            default: 'line'
        },
        tabsData: {
            type: Array,
            default: [
                {
                    tabKey: 1,
                    tabName: 'tab栏目',
                    tabDesc: '',
                    tabDisabled: false
                }
            ]
        }
    },
    data() {
        return {
        };
    },
    computed: {},
    mounted() {},
    watch: {},
    methods: {
        tabChange(e) {
            this.$emit("backTabs", e);
        }
    }
};
</script>
